export const messagesEndPoint = `comments`;
export const questionnairesCountEndPoint = `questionnaires/count`;
